<template>
  <div
    class="teacher"
    v-title
    :data-title="`卓考网校|卓考名师|${teacher.nickname}`"
  >
    <header class="g-header-container">
      <c-header title="卓考名师" />
    </header>
    <main class="g-view-container">
      <div class="baseInfo">
        <div
          class="bg"
          :style="'background-image:url(' + teacher.photoUrl + ');'"
        ></div>
        <div class="mask"></div>
        <div class="info">
          <img :src="teacher.photoUrl" class="avatar" />
          <h4 class="name">{{ teacher.nickname }}</h4>
          <div class="job">{{ teacher.tag }}</div>
        </div>
      </div>
      <van-tabs>
        <van-tab title="名师资料" />
      </van-tabs>
      <div class="intro">
        <h4 class="title">名师简介</h4>
        <div class="body">{{ teacher.summary }}</div>
      </div>

      <div class="feature">
        <h4 class="title">授课特点</h4>
        <div class="body">{{ teacher.description }}</div>
      </div>
    </main>
    <footer class="g-footer-container">
      <c-tabbar />
    </footer>
  </div>
</template>

<script>
  import axios from 'axios';
  import CHeader from 'components/header';
  import CTabbar from 'components/tabbar';

  export default {
    name: 'Teacher',
    data() {
      return {
        teacher: {},
      };
    },
    components: {
      CHeader,
      CTabbar,
    },
    created() {
      const { teacherId } = this.$route.params;
      axios
        .get(
          `https://api.zhuokao360.com/teacher/getTeacherById?teacherId=${teacherId}`,
        )
        .then(({ data: { code, data } }) => {
          if (code === 200) {
            this.teacher = data;
          }
        });
    },
  };
</script>

<style lang="scss" scoped>
@import "~assets/scss/mixins";
@mixin position-absolute() {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.baseInfo {
  position: relative;
  width: 100%;
  height: 220px;
  color: #fff;
  @include flex-center(column);

  .bg {
    @include position-absolute();
    z-index: -2;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    overflow: hidden;
    filter: blur(20px);
  }

  .mask {
    @include position-absolute();
    z-index: -1;
    background-color: rgba(0, 0, 0, 0.75);
  }

  .info {
    @include flex-center(column);

    .avatar {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      border: 2px solid rgba(255, 255, 255, 0.8);
    }

    .name {
      font-size: 18px;
      font-weight: bold;
      letter-spacing: 1px;
      line-height: 2.5;
    }

    .job {
      font-size: 16px;
    }
  }
}

.intro {
  margin: 8px 6px;
  padding: 20px 10px;
  color: #333;
  background-color: #fff;
  border-radius: 4px;

  .title {
    margin-bottom: 10px;
    font-size: 16px;
    font-weight: bold;
  }

  .body {
    font-size: 14px;
    line-height: 1.75;
    text-indent: 28px;
  }
}

.feature {
  @extend .intro;
}

.van-tabs {
  ::v-deep &__line {
    background-color: transparent;
  }
}
</style>
